var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found page_content"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("接口服务错误!")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }